import { BrowserSecurityService } from './browser';
import { MobileSecurityService } from './mobile';
import { EnvironmentVariables } from '../../constants/EnvironmentVariables';

class _SecurityService {
  private static _instance: _SecurityService;
  private _mobileSecurityService: MobileSecurityService | undefined;
  private _browserSecurityService: BrowserSecurityService | undefined;

  private constructor() {
    if (EnvironmentVariables.Is_Mobile === true) {
      this._mobileSecurityService = new MobileSecurityService(/*{ checkForRooting: false }*/);
      this._browserSecurityService = new BrowserSecurityService();
    } else {
      this._browserSecurityService = new BrowserSecurityService();
    }
  }

  public static Instance() {
    return this._instance || (this._instance = new this());
  }

  public async onStartupControl(): Promise<boolean> {
    let _mobileSecurityFailed: boolean = false;
    let _browserSecurityFailed: boolean = false;
    if (this._mobileSecurityService) {
      _mobileSecurityFailed = await this._mobileSecurityService.StartupControl();
    }
    if (this._browserSecurityService) {
      _browserSecurityFailed = this._browserSecurityService.StartupControl();
    }
    return _mobileSecurityFailed || _browserSecurityFailed;
  }

  public async onPageChangeControl(): Promise<boolean> {
    let _mobileSecurityFailed: boolean = false;
    let _browserSecurityFailed: boolean = false;
    if (this._mobileSecurityService) {
      _mobileSecurityFailed = await this._mobileSecurityService.PageChangeControl();
    }
    if (this._browserSecurityService) {
      _browserSecurityFailed = this._browserSecurityService.PageChangeControl();
    }
    return _mobileSecurityFailed || _browserSecurityFailed;
  }

  public SanitizeInnerHtml = (input: string): string => {
    if (this._browserSecurityService) {
      return this._browserSecurityService.SanitizeInnerHtml(input);
    } else {
      return input;
    }
  };

  public URLSafeParams = (params: { name: string; value: any }[]): string => {
    if (this._browserSecurityService) {
      return this._browserSecurityService.URLSafeParams(params);
    } else {
      return '';
    }
  };

  public AddURLSafeParams = (params: { name: string; value: any }[]): string => {
    if (this._browserSecurityService) {
      return this._browserSecurityService.AddURLSafeParams(params);
    } else {
      return '';
    }
  };
}

export const SecurityService = _SecurityService.Instance();
